import { Component, OnInit , ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { UserService } from '../../services/user.service';
@Component({
  selector: 'app-game-launch',
  templateUrl: './game-launch.component.html',
  styleUrls: ['./game-launch.component.scss']
})

export class GameLaunchComponent implements OnInit {
  url: string;
  title: string;
  game: any;
  categories: any;
  cont: any;
  toolkit: any = false;
  private routeObs: Subscription;
  @ViewChild('appGameTutorial') appGameTutorial;
  public games = [
    {
      title: 'Incendios Forestales',
      img: '/assets/games/fuego-04.jpg',
      theme: 1,
      link: 'juego-inicio/incendios'
    },
    {
      title: 'Humedales',
      theme: 2,
      img: '/assets/games/fuego-01.jpg',
      link: 'juego-inicio/humedales'
    },
    {
      title: 'Criaturas amazónicas',
      theme: 3,
      img: '/assets/games/fuego-02.jpg',
      link: 'http://bufeo.wwfbolivia.org/'
    }
  ]

  constructor(private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public user: UserService,
    public api: RestapiService) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        this.loadGame();
      }, 10);
    });
  }

  ngOnInit(): void {
    this.loadGame();
  }

  loadGame() {
    this.url = this.activatedRoute.snapshot.paramMap.get('game');
    switch (this.url) {
      case 'incendios-forestales':
        this.game = this.games[0];
        this.title = 'Incendios Forestales';
        this.api.getdata('websection', { filters: {
          webroute_id: { value: 9 } ,
          webcontext_id: { value: 12 } ,
        } })
        .subscribe(res=>{
          this.categories = res.result.data;
          console.log('secciones', this.categories);
        });
        break;
      case 'humedales':
        this.game = this.games[0];
        this.title = 'Humedales';
        this.api.getdata('websection', { filters: {
          webroute_id: { value: 9 } ,
          webcontext_id: { value: 13 } ,
        } })
        .subscribe(res=>{
          this.categories = res.result.data;
          console.log('secciones', this.categories);
        })
        break;
    }
  }


  showToolkit(){
    this.toolkit = !this.toolkit;
  }
}
